module.exports = __webpack_public_path__ + "i.no2.10b0fccf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/i.no2.jpg
// module id = LRC4
// module chunks = 0